<div class="container-fluid"
     id="manageEmployee">
    <section class="pageTitle-block">
        <div class="col-md-12 no-padding-right-left position-relative">
            <div class="row">
                <div class="col-xl-8 col-lg-8 col-md-8 col-sm-8 col-xs-8 padding-left-0">
                    <div class="pageTitle">
                        <div class="viewDemo">
                            <ul>
                                <li class="no-padding-right-left">
                                    <h2 class="padding-right"><em>{{ "header_setup_grades_and_assign_claimants" | translate : param
                                            }}</em> </h2>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>

                <div class="col-xl-4 col-lg-4 col-md-4 col-sm-4 col-xs-4 padding-right-0 header-icons text-right">
                    <div class="actionItems">
                        <ul>
                            <li class="btn-default padding-right-0"
                                (click)="backToSettings()">
                                <button><span><em class="fas fa-reply-all icon-themeColor"></em>{{
                                        "label_back_to_settings" | translate : param }}</span> </button>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    </section>
    <app-wizard [wizardDetails]="wizardDetails"
                (StepClickEvent)="navigateToStep($event)">
    </app-wizard>
    <grade-panel *ngIf="showgradePanel"
                                               (closePanelEvent)="closeGradePanel($event)"
                                               [PanelData]="gradePanelData">
    </grade-panel>

    <grade-assign-category-list-panel *ngIf="showAssignCategoriesToGradeListPanel" [(inputModel)]="assignCategoriesToGradeListPanelInputModel"
    (closePanelEvent)="fnCloseAssignCategoriesToGradeListPanel($event)"></grade-assign-category-list-panel>

    <grade-assign-employee *ngIf="showAssignClaimantToGradePopup" 
    (closePanelEvent)="closeAssignClaimanttogradePopup()">
    </grade-assign-employee>

    
    <marketing-popup *ngIf="isMarketingPopup"
                     [data]="marketingPopupPanel"
                     (closePanel)="closeMarketingPopup()">
    </marketing-popup>
    
    <app-alert-panel [data]="alertPanelModel"
                     (callbackEvent)="alertPanelReceiver($event)">
    </app-alert-panel>
    <grade-import-export-panel *ngIf="showGradeImportExportPanel" 
    (closePanelEvent)="fnCloseGradeImportExportPanel($event)">
    </grade-import-export-panel>
    

    


</div>

